module.exports = __webpack_public_path__ + "static/media/slider-business-slide-03-image-01.0a2f51e8.png";